import React, { useState } from "react";
import ContactPopupWidget from "./ContactPopupWidget.jsx";

const ContactWidget = ({ config }) => {
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [showRoleRequired, setShowRoleRequired] = useState(false);
  const loginPopUp = document.getElementById("login-popup-wrapper");
  
  const has_role_permission = config.has_role_contact_permission.toLowerCase() === "true"

  const handleOpenPopUp = () => {
    if (!has_role_permission) {//Si hay declarado un rol requerido chequea la condicion
      setShowRoleRequired(true);
    } else {
      setIsPopUpOpen(true);
    }
  };
 
  const handleClosePopUp = () => {
    setIsPopUpOpen(false);
  };
  const showLoginPopUp = () => {
    if (loginPopUp) {
      loginPopUp.classList.add("popup-visible");
    }
  };
  return (
    <>
      <div className="ContactWidget">
        <i className="icon-enviar"></i>
        <h3 className="ContactWidget_title">{config.translations.contactTitle}</h3>
        <span className="ContactWidget_subtitle"> {config.translations.contactSubTitle}</span>
        <button
          onClick={
            config.profile === ""
              ? () => showLoginPopUp()
              : () => handleOpenPopUp()
          }
          className="ContactWidget_button"
        >
          <i className="icon-chat"></i> {config.translations.contactTxtBtn}
        </button>
        <p className="ContactWidget_roleWarning">
          {showRoleRequired && config.translations.contactNoPermission}
        </p>
      </div>
      {isPopUpOpen && (
        <ContactPopupWidget handleClosePopUp={handleClosePopUp} config={config}/>
      )}
    </>
  );
};

export default ContactWidget;
